import comp from "./StatusIcon";
export default comp;
